import { render } from "./Cta.vue?vue&type=template&id=64ba6201"
import script from "./Cta.vue?vue&type=script&lang=js"
export * from "./Cta.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__